<template>
  <div v-if="values">
    <div class="w-80 text-gray-500">
      <p>
        <span>{{ $t("商品总额") }}：</span>
        <span>{{ $p(values.total) }}</span>
      </p>
      <!-- <p>
        <span>{{ $t("运费") }}：</span>
        <span>{{ $p(values.express) }}</span>
      </p>
      <p>
        <span>{{ $t("促销立减") }}：</span>
        <span>{{ $p(values.discount) }}</span>
      </p>
      <p>
        <span>{{ $t("包装费") }}：</span>
        <span>{{ $p(values.package) }}</span>
      </p>
      <p>
        <span class="text-blue-400">{{ $t("预估报关报检费") }}：</span>
        <span>{{ $p(values.declare) }}</span>
      </p> -->
      <p class="mt-2">
        <span>{{ $t("实际付款") }}：</span>
        <span class="text-red-500 text-3xl ml-0">{{ $p(values.total) }}</span>
      </p>
    </div>
  </div>
</template>
<script>
export default {
  props: { values: Object }
};
</script>

<style scoped lang="scss">@import "@/style/stl.scss";
p {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: end;
  -ms-flex-align: end;
  -webkit-align-items: flex-end;
  align-items: flex-end;
}
p >span+span {
  margin-left: auto;
}</style>
